<div class="d-flex">
  <mat-card class="p-2 d-flex w-100">
    <div class="form-group col-md-2 my-auto pl-0" matTooltip="ETL Cycle">
      <select class="form-control" [(ngModel)]="etlProcess">
        <option value="">Select ETL Cycle</option>
        <option *ngFor="let item of processList['etl_process']">{{item}}</option>
      </select>
    </div>
    <div class="form-group col-md-2 my-auto pl-0" matTooltip="ETL Cycle">
      <select class="form-control" [(ngModel)]="execNumber">
        <option value="">Select Execution Number</option>
        <ng-container *ngIf="processList && processList['exec_number'] && processList['exec_number'][etlProcess]">
          <option *ngFor="let item of processList['exec_number'][etlProcess]">{{item}}</option>
        </ng-container>
      </select>
    </div>
    <div class="form-group col-md-2 my-auto pl-0" matTooltip="Entity">
      <select class="form-control" [(ngModel)]="entity" (change)="getCompanyPeriod()">
        <option value="">Select Entity</option>
        <option *ngFor="let item of processList['entity']">{{item}}</option>
      </select>
    </div>
    <div class="form-group col-md-2 my-auto pl-0" matTooltip="Company">
      <select class="form-control" [(ngModel)]="company">
        <option value="">Select Company</option>
        <option *ngFor="let item of companyPeriodList['Company']">{{item}}</option>
      </select>
    </div>
    <div class="form-group col-md-2 my-auto pl-0" matTooltip="Period">
      <select class="form-control" [(ngModel)]="glPeriod">
        <option value="">Select period</option>
        <option *ngFor="let item of companyPeriodList['Period']">{{item}}</option>
      </select>
    </div>
    <!-- <button mat-raised-button color="primary" class="">Get Data</button> -->
  <!-- </mat-card>
  <mat-divider [vertical]="true"></mat-divider>
  <mat-card class="p-2 d-flex w-50"> -->
    <button mat-raised-button color="primary" class="" (click)="getGLBalanceSheet()">Get Data</button>
  </mat-card>
</div>

<div class="w-100" *ngFor="let item of glBalanceSheetKey">
  <p class="ml-2">{{ item }}</p>
  <mat-card class="mb-2 custom-table p-0">
    <mat-progress-spinner *ngIf="loading" mode="indeterminate"></mat-progress-spinner>
    <table mat-table class="w-100" [dataSource]="glBalanceSheetData[item]">
      <ng-container *ngFor="let data of displayedColumns[item]">
        <ng-container *ngIf="data === 'Type'">
          <ng-container matColumnDef="Type" sticky>
            <th class="custom-color col-md-4" mat-header-cell *matHeaderCellDef> Type </th>
            <td class="custom-color col-md-4" mat-cell *matCellDef="let element"> {{element.Type}} </td>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="data !== 'Type'">
          <ng-container matColumnDef="{{ data }}">
            <th class="custom-color" mat-header-cell *matHeaderCellDef>{{ data }}</th>
            <td mat-cell *matCellDef="let element">
              <span class="ellipsis-style">{{ element[data] }}</span>
            </td>
          </ng-container>
        </ng-container>
      </ng-container>
  
      <!-- <ng-container matColumnDef="star" stickyEnd>
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <mat-icon>more_vert</mat-icon>
        </td>
      </ng-container> -->
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns[item]; sticky: true;"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns[item];"></tr>
    </table>
    <ng-container *ngIf="glBalanceSheetData[item] && glBalanceSheetData[item].length === 0">
      <p class="text-center mb-2">No data available.</p>
    </ng-container>
  </mat-card>
</div>